"use client";

import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Grid,
  GridItem,
  Divider,
  Badge,
  VStack,
  HStack,
  Icon,
  BoxProps,
} from "@chakra-ui/react";
import { ClientData } from "./types";

interface ClientDetailsProps extends BoxProps {
  client: ClientData;
}

const DetailItem = ({ label, value, textTransform }: { label: string; value: string | React.ReactNode; textTransform?: "none" | "uppercase" | "lowercase" | "capitalize" | "full-width" | "full-size-kana" }) => (
  <Flex direction="column" gap={1} minW={0}>
    <Text fontSize="xs" color="gray.500">
      {label}
    </Text>
    {typeof value === "string" ? (
      <Text 
        fontSize="sm" 
        fontWeight="medium" 
        color="blue.900"
        wordBreak="break-word"
        whiteSpace="normal"
        overflowWrap="break-word"
        maxW="100%"
        textTransform={textTransform}
      >
        {value}
      </Text>
    ) : (
      value
    )}
  </Flex>
);

const ClientDetails: React.FC<ClientDetailsProps> = ({ client, ...boxProps }) => {
  return (
    <Box
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="md"
      p={4}
      bg="white"
      w="full"
      {...boxProps}
    >
      <VStack align="stretch" spacing={4}>
        <Heading fontSize="md" color="blue.900">
          Client Details
        </Heading>
        
        <Divider />
        
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }}
          gap={6}
          w="100%"
          minW={0}
        >
          
          <DetailItem 
            label="Decision Makers" 
            value={
              <HStack spacing={1}>
                {Array.isArray(client.decisionMakers) && client.decisionMakers.map((person: string, index: number) => (
                  <Badge key={index} colorScheme="blue" variant="subtle" px={2} py={1}>
                    {person}
                  </Badge>
                ))}
              </HStack>
            } 
          />
          <DetailItem textTransform="capitalize" label="Name" value={client.name} />

          <DetailItem label="Email" value={client.email} />

          <DetailItem label="Phone" value={client.phone} />
          
          <DetailItem label="Residence" value={client.residence} />
          
          
          {/* <DetailItem 
            label="Intent" 
            value={
              <Badge 
                colorScheme={client.intent === "High" ? "green" : client.intent === "Medium" ? "yellow" : "red"} 
                variant="subtle" 
                px={2} 
                py={1}
              >
                {client.intent}
              </Badge>
            } 
          /> */}
        </Grid>
      </VStack>
    </Box>
  );
};

export default ClientDetails;